var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn"},[_vm._t("image"),_vm._t("text")],2)}
var staticRenderFns = []

export { render, staticRenderFns }